import React from 'react';
import './styles.css';

const PaymentDelivery = () => {
    return (
        <div className="pd-page">
            <div className="pd-container">
                <h1 className="pd-title">Оплата и доставка</h1>

                <section className="pd-section">
                    <p>При оформлении и оплате заказа через наш интернет-магазин:</p>
                    <ul>
                        <li>Вы получаете оперативную отправку и доставку Вашего заказа в указанные сроки;</li>
                        <li>Мы гарантируем уровень сервиса при доставке заказа;</li>
                        <li>Мы контролируем процесс доставки: с момента отправки Вашего заказа со склада и до его вручения Вам!</li>
                    </ul>
                </section>

                <section className="pd-section">
                    <h2>Схемы доставки включают в себя:</h2>
                    <p>
                        На маркетплейсе e-feed.ru предусмотрены несколько вариантов доставки товаров. Вы можете выбрать
                        подходящий способ доставки при оформлении и оплате заказа.
                    </p>
                    <ul>
                        <li>
                            Доставка транспортной компанией. Если рядом нет пунктов выдачи заказов, то можно воспользоваться
                            этой опцией. Стоимость доставки рассчитывается при оформлении покупки.
                        </li>
                        <li>
                            Доставка собственным транспортом e-feed.ru. Рассмотрите этот способ, если вам необходима крупная
                            партия партия тяжелого товара, например, комбикормов в биг бэгах.
                        </li>
                    </ul>
                    <p>
                        Стоимость и сроки доставки зависят от выбранного Вами варианта доставки и объема заказа, и указываются
                        при оформлении заказа.
                    </p>
                    <p>
                        Доставка осуществляется собственным транспортом компании.
                    </p>
                    <p>
                        Команда маркетплейса E-feed.ru постоянно работает над ускорением доставки грузов от распределительных
                        центров до наших клиентов. Весь процесс оцифрован и контролируется на каждом этапе, от отгрузки
                        продавцом, до вручения вам в руки.
                    </p>
                </section>

                <section className="pd-section">
                    <p>Для оплаты заказа доступны следующие способы:</p>
                    <ol>
                        <li>Банковской картой (Visa, MasterCard, МИР)</li>
                        <li>Перечислением на расчетный счет компании по выставленному счету</li>
                    </ol>
                    <p>Все механизмы оплаты надежно защищены и безопасны.</p>
                    <p>
                        Для оплаты (ввода реквизитов вашей карты) вы будете перенаправлены на платежный шлюз Тинькофф банк.
                    </p>
                    <p>
                        Соединение с платежным шлюзом и передача информации осуществляется в защищенном режиме с использованием
                        протокола шифрования SSL, так что ваши данные в полной безопасности.
                    </p>
                    <p>
                        За конфиденциальность сообщаемой персональной информации отвечает Тинькофф банк.
                    </p>
                    <p>
                        Введенная информация не будет предоставлена третьим лицам, за исключением случаем предусмотренных
                        законодательством РФ.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default PaymentDelivery;
